import { useCallback, useState } from 'react'
import { createPortal } from 'react-dom'
import { FiX } from 'react-icons/fi'

import { Button } from '~/components/Button'

import { NewEvaluationButton } from '../NewEvaluationButton'
import { UpdateStudentForm } from '../UpdateStudent/updateStudentForm'
import { Card } from './Card'
import { EvaluationsArea } from './EvaluationsArea'

export const StudentDetailsModal: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [isAnimating, setIsAnimating] = useState<boolean>(false)

  const handleToggleModal = useCallback(() => {
    if (!open) {
      setOpen(true)
      // Delay to allow initial render before animating
      setTimeout(() => setIsAnimating(true), 50)
    } else {
      setIsAnimating(false)
      setTimeout(() => setOpen(false), 600) // Match total animation duration (300ms delay + 300ms duration)
    }
  }, [open])

  return (
    <>
      <Button onClick={handleToggleModal} mode='outlined'>
        Detalhes do Aluno
      </Button>
      {open
        ? createPortal(
            <div className='stack fixed inset-0 z-20'>
              <div
                className={`relative bg-slate-50/10 w-full h-full transition-all duration-300 ${
                  isAnimating
                    ? 'backdrop-blur-sm delay-0'
                    : 'backdrop-blur-none delay-300'
                }`}
              ></div>

              <div className='relative w-full h-full py-12 px-8 overflow-y-auto'>
                <div
                  className={`flex flex-col gap-8 max-w-[880px] mx-auto transition-all duration-300 ${
                    isAnimating
                      ? 'translate-y-0 opacity-100 delay-300'
                      : 'translate-y-8 opacity-0 delay-0'
                  }`}
                >
                  <Card>
                    <div className='flex items-center justify-between'>
                      <h3 className='font-semibold text-2xl'>
                        Detalhes do Aluno
                      </h3>

                      <button
                        type='button'
                        className='p-3 rounded-full bg-slate-50
                      hover:bg-slate-100'
                        onClick={handleToggleModal}
                      >
                        <FiX size={20} />
                      </button>
                    </div>
                  </Card>

                  <Card>
                    <div className='flex items-center justify-between mb-6'>
                      <h3 className='text-lg font-semibold'>Avaliações</h3>
                      <div>
                        <NewEvaluationButton />
                      </div>
                    </div>

                    <EvaluationsArea />
                  </Card>

                  <Card>
                    <h3 className='text-lg font-semibold'>Dados do Aluno</h3>
                    <UpdateStudentForm
                      onSubmit={() => {
                        console.log('success')
                      }}
                    />
                  </Card>
                </div>
              </div>
            </div>,
            document.body,
          )
        : null}
    </>
  )
}
